/* Moment */
import moment from "moment"


/* The kinds of a payment — the words, the colour and the sign */
export const KINDS = {
    initial: { text: "Первая оплата", hint: "Точка оплатила картой в Pro", accent: "blue", icon: "card" },
    recurring: { text: "Автопродление", hint: "Списание по сохранённой карте", accent: "green", icon: "refresh" },
    manual: { text: "Вручную", hint: "Срок продлён в админке: наличные или перевод", accent: "violet", icon: "edit" },
    invoice: { text: "По счёту", hint: "Оплата по выставленному счёту", accent: "orange", icon: "booking" },
    promo: { text: "Промокод", hint: "Бесплатные месяцы по промокоду при открытии точки", accent: "teal", icon: "ticket" },
    certificate: { text: "Сертификат", hint: "Подарочный сертификат с сайта", accent: "pink", icon: "gift" }
}

export const kindOf = key => {
    return KINDS[key] ? KINDS[key] : { text: key ? key : "—", hint: "", accent: "grey", icon: "wallet" }
}

/* The states of a payment */
export const STATUSES = {
    success: { text: "Оплачен", accent: "green", icon: "check" },
    failed: { text: "Отказ", accent: "red", icon: "close" },
    pending: { text: "Не завершён", accent: "orange", icon: "clock" }
}

export const statusOf = key => {
    return STATUSES[key] ? STATUSES[key] : STATUSES.pending
}

/* The terms of a subscription */
export const PLANS = {
    monthly: "Месяц",
    quarterly: "Квартал",
    semiannual: "Полгода",
    annual: "Год"
}

/* The life of a gift certificate after the payment */
export const CERTIFICATE_STATES = {
    pending: { text: "Ждёт оплаты", accent: "orange" },
    failed: { text: "Оплата не прошла", accent: "red" },
    active: { text: "Активен", accent: "green" },
    used: { text: "Использован", accent: "blue" },
    expired: { text: "Истёк", accent: "grey" }
}

/* The periods of the page — each one turns into two dates for the server */
export const PERIODS = [
    { key: "month", text: "Этот месяц" },
    { key: "previous", text: "Прошлый месяц" },
    { key: "days30", text: "30 дней" },
    { key: "days90", text: "90 дней" },
    { key: "year", text: "Год" },
    { key: "all", text: "Всё время" }
]

export const periodOf = key => {

    const today = moment()
    const format = value => value.format("YYYY-MM-DD")

    if (key === "previous") {
        const previous = moment().subtract(1, "month")
        return { from: format(moment(previous).startOf("month")), to: format(moment(previous).endOf("month")) }
    }

    if (key === "days30") {
        return { from: format(moment().subtract(29, "days")), to: format(today) }
    }

    if (key === "days90") {
        return { from: format(moment().subtract(89, "days")), to: format(today) }
    }

    if (key === "year") {
        return { from: format(moment().startOf("year")), to: format(today) }
    }

    if (key === "all") {
        return { from: "", to: "" }
    }

    return { from: format(moment().startOf("month")), to: format(today) }
}

/* The last four digits of a card */
export const cardOf = pan => {

    const digits = `${pan || ""}`.replace(/\D/g, "")

    if (digits.length < 4) {
        return null
    }

    return `•• ${digits.slice(-4)}`
}

/* A sum in short: 1,2 млн, 950 тыс */
export const shortMoney = value => {

    const number = parseInt(value) || 0

    if (number >= 1000000) {
        return `${(number / 1000000).toFixed(1).replace(".", ",").replace(",0", "")} млн`
    }

    if (number >= 10000) {
        return `${Math.round(number / 1000)} тыс`
    }

    return number.toLocaleString("ru-RU")
}
